import { FETCH_AUTH_INFO } from "@/store/action-types"

export default async function verified({ next, store, to }) {

    const isLogin = await store.state.auth.isLoggedIn

    if (!isLogin) {
        next('/login')
        return
    }


    await store.dispatch(FETCH_AUTH_INFO)

    let user = store.state.auth.authUser
    let emailVerifiedAt = null

    if (user) {
        emailVerifiedAt = user.emailVerifiedAt;
    }


    if (!user || emailVerifiedAt == null) next('/verify-token')

    if (user.stations.length == 0) location.href = `${process.env.VUE_APP_BASE_URL}/pricing`

    else next()

}